export default __webpack_public_path__ + "static/media/Property 1=Open.207f3524.svg";